export default "__VITE_ASSET__8YXL1tk2__"